import React, { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { useLazyUsersListQuery } from '../service/adminUsersApi';
import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import { CommonTableProps } from '../../../../crm/interfaces/common.interface';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import { UsersAdminProps, UsersFiltersProps } from '../service/users.inteface';
import { getColumns } from '../utils/getColumns';
import { Download, Type } from '../../../components/Download';
import UniversalTable from '../../../components/UniversalTable';

export const UsersContainer = () => {
    const { updateFilters, filters, get, source, loading } = useFilters<
        UsersFiltersProps,
        UsersAdminProps
    >(useLazyUsersListQuery, null);

    const tableProps = useMemo<
        CommonTableProps<UsersAdminProps, UsersFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
            getColumns,
            entityName: 'Участников',
            rowKey: ({ id }) => id,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            get({ filters: filters }, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get]);

    return (
        <>
            <Download type={Type.users} />
            <UniversalTable {...tableProps} />
            <Outlet />
        </>
    );
};
